import React from 'react';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import {
  FaEnvelope,
  FaWhatsapp,
  FaHeadset,
  FaClock,
  FaArrowRight,
  FaComments,
  FaPhoneAlt
} from 'react-icons/fa';
import '../../../component/css/custom-scrollbar.css'

const Support = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();

  const supportChannels = [
    {
      icon: <FaEnvelope className="w-8 h-8 text-white" />,
      title: 'Email Support',
      description: 'Comprehensive support via email. Detailed responses within 24 hours.',
      contact: 'support@pickupxpress.com',
      link: 'mailto:support@pickupxpress.com',
      color: 'bg-gradient-to-br from-indigo-600 to-purple-700',
      hoverColor: 'hover:from-indigo-700 hover:to-purple-800',
    },
    {
      icon: <FaWhatsapp className="w-8 h-8 text-white" />,
      title: 'WhatsApp Support',
      description: 'Instant messaging support for quick resolutions.',
      contact: '+91XXXXXX0087',
      link: 'https://wa.me/message/LCC4KAGD5JFUC1',
      color: 'bg-gradient-to-br from-green-500 to-emerald-600',
      hoverColor: 'hover:from-green-600 hover:to-emerald-700',
    }
  ];
  return (
    <div
      className={`min-h-screen flex flex-col overflow-hidden ${isDarkMode
          ? 'dark:bg-gradient-to-br dark:from-darkmodeColor dark:to-[rgba(7,28,110,0.96)]'
          : 'bg-gray-50'
        }`}
    >
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>
        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div
              className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                  : {}
              }
            >
              <Sidebar />
            </div>
          )}
            <div className="flex-1 p-6 md:p-8 lg:p-12 bg-gray-100 overflow-y-auto custom-scrollbar">
              <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-12 space-y-6">
                  <div className="relative inline-block">
                    <div className="absolute -inset-2 bg-indigo-400/20 dark:bg-indigo-400/10 blur-xl rounded-full animate-pulse"></div>
                  <div className="relative bg-white dark:bg-darkmodeColor p-6 rounded-full shadow-2xl">
                    <FaHeadset className="w-20 h-20 text-indigo-600 dark:text-indigo-400 transform hover:scale-110 transition-transform" />
                  </div>
                </div>
                <h1 className="text-5xl font-extrabold mt-6 
                bg-clip-text text-transparent 
                bg-gradient-to-r from-indigo-600 to-purple-600 
                dark:from-indigo-400 dark:to-purple-500">
                  Customer Support
                </h1>
                <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
                  Our dedicated support team is committed to providing exceptional service.
                  We're here to help you with any questions or concerns you may have.
                </p>
              </div>

              {/* Primary Support Channels */}
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                {supportChannels.map((channel, index) => (
                  <div
                    key={index}
                    className={`
                    group relative overflow-hidden
                    bg-white dark:bg-[rgba(15,25,100,0.8)]
                    rounded-3xl shadow-2xl 
                    transform transition-all duration-300 
                    hover:-translate-y-2 hover:shadow-3xl
                    border border-gray-100 dark:border-gray-800
                  `}
                  >
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-10 
                    bg-gradient-to-r from-indigo-200 to-purple-200 dark:from-indigo-900 dark:to-purple-900 
                    transition-opacity duration-300"></div>

                    <div className="relative p-8 space-y-6">
                      <div className={`${channel.color} p-4 rounded-2xl inline-block shadow-lg`}>
                        {channel.icon}
                      </div>
                      <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                        {channel.title}
                      </h2>
                      <p className="text-gray-600 dark:text-gray-300 text-base">
                        {channel.description}
                      </p>
                      <div className="flex items-center space-x-3">
                        <span className="font-semibold text-gray-700 dark:text-gray-200">
                          {channel.contact}
                        </span>
                      </div>
                      <a
                        href={channel.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`
                        inline-flex items-center justify-between
                        ${channel.color} ${channel.hoverColor}
                        text-white px-6 py-3 rounded-xl
                        font-semibold text-base
                        transition-all duration-300
                        hover:shadow-xl
                        group/link
                      `}
                      >
                        <span>Contact Support</span>
                        <FaArrowRight className="ml-3 w-4 h-4 
                        transform group-hover/link:translate-x-1 
                        transition-transform duration-300"
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              {/* Business Hours Card */}
              <div className="mt-12">
                <div
                  className="
                  bg-white dark:bg-[rgba(15,25,100,0.8)] 
                  rounded-3xl shadow-2xl 
                  border border-gray-100 dark:border-gray-800
                  overflow-hidden
                "
                >
                  <div className="p-8 text-center">
                    <div className="flex items-center justify-center space-x-4 mb-6">
                      <FaClock className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
                      <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
                        Business Hours
                      </h3>
                    </div>
                    <div className="space-y-4 text-gray-600 dark:text-gray-300">
                      <p className="text-xl font-semibold">
                        Monday to Saturday : 9:00 AM - 6:00 PM
                      </p>
                      <p className="text-base max-w-2xl mx-auto">
                        For urgent matters outside business hours, our WhatsApp support channel
                        provides immediate assistance to ensure you're never left without help.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;